import {NodePropertiesPane} from '../../SidePanel/RightPanel/NodePane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import ArTypeCode from './PropertiesControllerArTypeCode.jsx'
import Model from './ModelAr.mjs'

const PropertiesPaneAr = (props) => (
    <NodePropertiesPane
        Model={Model}
        {...props}
    >
        <LongText prop="arName" />
        <ArTypeCode prop="arTypeCode" />
    </NodePropertiesPane>
)

export default PropertiesPaneAr
